import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "TabView" */ './lazyIndex');
});
export var TabBar = createLazyComponent(lazyModule, function (m) { return m.TabBar; });
//# sourceMappingURL=index.js.map